// @ts-strict-ignore
import {Component, Input, OnInit} from "@angular/core";
import {DisplayMode, Permissions} from "@models";
import {CameraLayoutOptionsContainer} from "../../../../types/camera-layout-options";
import {BaseRecorderLayout} from "../base-recorder-layout";

@Component({
	selector: "sim-recorder-layout-single",
	templateUrl: "./recorder-layout-single.component.html",
	styleUrls: ["./recorder-layout-single.component.scss"],
	standalone: false,
})
export class RecorderLayoutSingleComponent extends BaseRecorderLayout implements OnInit {
	@Input() cameraLayoutOptionsContainer: CameraLayoutOptionsContainer;
	@Input() screenIndexOverride: number = undefined;

	constructor() {
		super();
	}

	ngOnInit() {}
}
